import { z } from 'zod';

import { SubscriptionDuration, SubscriptionType } from '../../../types/plan.types';

export const formSchema = z
  .object({
    planType: z.enum(SubscriptionType),
    amount: z.coerce.number({ message: 'Please enter a numeric value' }),
    stakeholderLimit: z.coerce.number({ message: 'Please enter a numeric value' }),
    currency: z.string(),
    frequency: z.enum(SubscriptionDuration),
    docusignEnvelopeLimit: z.preprocess(
      (val) => (val === '' || val === undefined ? undefined : Number(val)),
      z
        .number()
        .int('Must be a whole number')
        .positive('Must be at least 1')
        .max(10000, 'Cannot exceed 10000')
        .optional(),
    ),
  })
  .superRefine((data, ctx) => {
    if (data.amount < 1) {
      ctx.addIssue({ code: 'custom', path: ['amount'], message: 'Required' });
    }
    if (data.stakeholderLimit < 1) {
      ctx.addIssue({ code: 'custom', path: ['stakeholderLimit'], message: 'Required' });
    }
  });

export type FormSchema = z.infer<typeof formSchema>;
